import { Component, DestroyRef, OnInit, computed, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormFieldComponent } from '../../shared/components/form-field/form-field.component';
import { ButtonPadraoComponent } from '../../shared/components/button-padrao/button-padrao.component';
import { JsonEditorComponent } from '../../shared/components/json-editor/json-editor.component';
import { MsgService } from '../../shared/service/msg.service';
import { WebhookService } from '../../shared/service/webhook.service';
import { WebhookModel } from '../../shared/model/webhook-model';

@Component({
  selector: 'app-card-webhook',
  standalone: true,
  imports: [
    FormFieldComponent,
    ButtonPadraoComponent,
    JsonEditorComponent
  ],
  templateUrl: './card-webhook.component.html',
  styleUrl: './card-webhook.component.css'
})
export class CardWebhookComponent implements OnInit {

  private readonly msgService = inject(MsgService);
  private readonly webHookService = inject(WebhookService);
  private readonly destroyRef = inject(DestroyRef);

  webhook: WebhookModel = new WebhookModel();

  readonly url = signal<string>('');
  readonly clienteToken = signal<string>('');
  readonly salvando = signal<boolean>(false);
  readonly carregando = signal<boolean>(true);

  readonly payloadFixo =
    '{\n  "telefone": "5511999999999",\n  "novaMensagemRecebida": true,\n  "novaMensagemEnviada": false,\n  "grupoId": 123,\n  "isMensagemCliente": true,\n  "idMensagem": "msg-abc-001",\n  "isReprocessamento": false,\n  "mensagemBot": false\n}';

  private readonly urlValida = computed(() => this.validarFormatoUrl(this.url()));

  private readonly motivoBloqueio = computed<string | null>(() => {
    if (!this.url().trim()) return 'Informe a URL responsável pelo recebimento do evento.';
    if (!this.urlValida()) return 'A URL informada não é válida. Use um endereço http(s).';
    if (!this.clienteToken().trim()) return 'Informe o token de autenticação da plataforma de origem.';
    return null;
  });

  ngOnInit() {
    this.buscarWebhook();
  }

  buscarWebhook() {
    this.webHookService.buscarWebhook().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: res => {
        if (res) {
          this.webhook = res;
          this.url.set(res.url ?? '');
          this.clienteToken.set(res.clienteToken ?? '');
        }
        this.carregando.set(false);
      },
      error: () => {
        this.carregando.set(false);
        this.msgService.msgErro('Erro ao carregar a configuração do webhook');
      }
    });
  }

  salvarWebHook() {
    const motivo = this.motivoBloqueio();
    if (motivo) {
      this.msgService.msgAdvertencia(motivo);
      return;
    }
    if (this.salvando()) {
      return;
    }

    this.webhook.url = this.url().trim();
    this.webhook.clienteToken = this.clienteToken().trim();

    this.salvando.set(true);
    this.webHookService.salvarWebHook(this.webhook).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: () => {
        this.msgService.msgSucesso('Webhook salvo com sucesso!');
        this.buscarWebhook();
      },
      error: (err) => {
        this.msgService.msgErro(err?.error?.message ?? 'Ocorreu um erro ao tentar salvar o webhook');
      },
      complete: () => this.salvando.set(false)
    });
  }

  private validarFormatoUrl(valor: string): boolean {
    const v = (valor ?? '').trim();
    if (!v) return false;
    try {
      const u = new URL(v);
      return u.protocol === 'http:' || u.protocol === 'https:';
    } catch {
      return false;
    }
  }
}
